function ChangePageRdc() {
    const changePageRdc = (state, payload) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, page: payload });
    };
    return changePageRdc;
}
export default ChangePageRdc;
//# sourceMappingURL=ChangePageRdc.js.map